import type { PageLoad } from './$types';

export const load = (async ({ data, parent }) => {
	const { symbol } = await parent();
	const title = `${symbol.name} (${symbol.exchangeTicker}) Dividends`;
	const description = `Get the latest ${symbol.name} (${symbol.exchangeTicker}) dividends, including dividend yield, ex-dividend date, and record date. Calculate your dividend amount with our dividend calculator.`;
	return {
		...data,
		title,
		description,
		pageContext: 'tool-stock-tool-dividend'
	};
}) satisfies PageLoad;
